import apiService from './apiService';

class LLMService {
  // Fetch all LLM providers (for the agent-builder model picker).
  async getProviders() {
    try {
      // Add a small delay to make loading state visible (remove in production)
      await new Promise(resolve => setTimeout(resolve, 1000));

      const data = await apiService.getProviders(true);
      console.log('Providers API response:', data);
      // Exclude Cohere: it's a knowledge-base search re-ranking provider (no chat
      // models), so choosing it as an agent's LLM would fail every run. It stays
      // visible in the LLM key panels — this filter only affects the model picker.
      const list = Array.isArray(data) ? data : (data?.providers || []);
      return list.filter((p) => String(p?.name || '').toLowerCase() !== 'cohere');
    } catch (error) {
      console.error('Error fetching providers:', error);
      throw error;
    }
  }

  // Fetch models for a specific provider
  async getModelsByProvider(providerId) {
    try {
      // Add a small delay to make loading state visible (remove in production)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const data = await apiService.getModelsByProvider(providerId, true);
      console.log('Models API response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error;
    }
  }
}

const llmService = new LLMService();
export default llmService;
